const dateFormat = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

const timeOnlyFormat = new Intl.DateTimeFormat("en-US", {
  hour: "numeric",
  minute: "2-digit",
  hour12: true,
});

const dateOnlyFormat = new Intl.DateTimeFormat("en-US", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const shortDateOnlyFormat = new Intl.DateTimeFormat("en-US", {
  month: "short",
  day: "numeric",
  year: "numeric",
});

export function formatTimestamp(timestamp: number): string {
  return dateFormat.format(new Date(timestamp));
}

// Date with no time component, e.g. "January 1, 2026".
export function formatDate(timestamp: number): string {
  return dateOnlyFormat.format(new Date(timestamp));
}

// Compact date, short month, no time, e.g. "Jan 1, 2026".
export function formatDateShort(timestamp: number): string {
  return shortDateOnlyFormat.format(new Date(timestamp));
}

export function formatHoverTime(timestamp: number): string {
  const d = new Date(timestamp);
  const now = new Date();
  const isToday =
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate();
  return isToday ? timeOnlyFormat.format(d) : formatTimestamp(timestamp);
}
